<template>
  <div class="search">
    <input class="head-text" type="text" :placeholder="$t('search.placeholder')" v-model="query" />
    <drop-board
      position="bottom"
      v-show="open"
    >
      <m-layout-mask>
        <div class="search-result">
            <search-sport v-for="sport in sports" :key="sport.id" :sport="sport">
              <search-league v-for="league in sport.leagues" :key="league.id" :sport="sport.id" :league="league">
                <search-event
                  class="event"
                  v-for="event in league.events"
                  :key="event.id"
                  :event="event"
                  @click="open = false; query = ''; event.type === 0 ? $router.push(`/prematch/sport/${sport.id}/event/${event.id}`) : $router.push(`/live/sport/${sport.id}/event/${event.id}`);" />
              </search-league>
            </search-sport>
        </div>
      </m-layout-mask>
    </drop-board>
  </div>
</template>

<script>
import SearchService from '@/services/SearchService'
import SearchResult from '@/components/header/SearchResult'
import MScrollbar from '@/components/MScrollbar'
import DropBoard from '@/components/DropBoard'
import MLayoutMask from '@/components/layouts/MLayoutMask'
import SearchSport from '@/components/header/SearchSport'
import SearchLeague from '@/components/header/SearchLeague'
import SearchEvent from '@/components/header/SearchEvent'

export default {
  components: { DropBoard, SearchResult, MScrollbar, MLayoutMask, SearchSport, SearchLeague, SearchEvent },
  data () {
    return {
      query: '',
      sports: null,
      open: false
    }
  },
  watch: {
    async query (value) {
      if (value.length < 3) {
        this.open = false
      } else {
        const response = await SearchService.search({ query: value })
        this.sports = response.data.sports
        this.open = true
      }
    }
  }
}
</script>

<style scoped>
input { /* background: rgba(0,0,0,.25); */
    border: none;
    border-radius: .25rem;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    width: 226px;
    transition: background .3s;
    color: #231e4a;
    margin-bottom: 0px;
    margin-left: 5px;
    border: 1px solid #323232;
    margin-top: 5px;
}
input:focus { background: rgba(0, 0, 0, .5); }
input::-webkit-input-placeholder { color: #231e4a; }
input::-moz-placeholder { color: 231e4a; }
input:-ms-input-placeholder { color: 231e4a; }
input:-moz-placeholder { color: 231e4a; }
.search-result { position: fixed; width: 300px; background: white; position: fixed; z-index: 1; /* margin-top: 15px; border-radius: 5px;  */ border: 1px solid black; max-height: 560px; /* box-shadow: 0 0 10px black; */ contain: content; margin-left: 5px; }
</style>



// WEBPACK FOOTER //
// src/components/header/Search.vue